(function() {
  'use strict';

  var gridSelector = '#product-grid.AjaxinateLoop';
  var paginationSelector = '.AjaxinatePagination';
  var storagePrefix = 'rosyz:collection-scroll:';
  var appendedEvent = 'rosyz:collection-page-appended';
  var facetsRenderedEvent = 'rosyz:facets-rendered';
  var restoreStarted = false;
  var isRestoring = false;
  var facetRestorePending = false;
  var saveTimer = null;
  var previousScrollRestoration = null;

  function currentUrlKey() {
    return window.location.pathname + window.location.search;
  }

  function storageKey(urlKey) {
    return storagePrefix + urlKey;
  }

  function readState(urlKey) {
    try {
      var value = window.sessionStorage.getItem(storageKey(urlKey));
      return value ? JSON.parse(value) : null;
    } catch (error) {
      return null;
    }
  }

  function saveCurrent(includeLoadedCount) {
    if (isRestoring) return;
    var grid = document.querySelector(gridSelector);
    if (!grid) return;

    var gridContainer = document.getElementById('ProductGridContainer');
    var collection = grid.closest('.collection');
    var isLoading = (gridContainer && gridContainer.classList.contains('loading')) ||
      (collection && collection.classList.contains('loading'));
    var pagination = document.querySelector(paginationSelector);
    var mode = pagination && pagination.getAttribute('data-pagination');
    var loadedProductCount = null;

    if (includeLoadedCount !== false && !isLoading && (mode === 'click' || mode === 'scroll')) {
      loadedProductCount = grid.children.length;
    }

    try {
      window.sessionStorage.setItem(storageKey(currentUrlKey()), JSON.stringify({
        scrollY: window.pageYOffset || document.documentElement.scrollTop || 0,
        loadedProductCount: loadedProductCount
      }));
    } catch (error) {
      // Storage can be unavailable in private browsing; native restoration remains available.
    }
  }

  function setManualRestoration() {
    try {
      if ('scrollRestoration' in window.history && window.history.scrollRestoration !== 'manual') {
        previousScrollRestoration = window.history.scrollRestoration;
        window.history.scrollRestoration = 'manual';
      }
    } catch (error) {
      previousScrollRestoration = null;
    }
  }

  function resetScrollRestoration() {
    if (previousScrollRestoration === null) return;
    try {
      window.history.scrollRestoration = previousScrollRestoration;
    } catch (error) {
      // Leave the current browser setting unchanged if it cannot be reset.
    }
    previousScrollRestoration = null;
  }

  function waitForGrid(deadline) {
    return new Promise(function(resolve) {
      function check() {
        var grid = document.querySelector(gridSelector);
        if (grid || Date.now() >= deadline) {
          resolve(grid);
          return;
        }
        window.setTimeout(check, Math.min(50, Math.max(1, deadline - Date.now())));
      }
      check();
    });
  }

  function waitForAjaxinate(deadline) {
    return new Promise(function(resolve) {
      function check() {
        var instance = window.theme && window.theme.collectionAjaxinate;
        if (instance || Date.now() >= deadline) {
          resolve(instance || null);
          return;
        }
        window.setTimeout(check, Math.min(50, Math.max(1, deadline - Date.now())));
      }
      check();
    });
  }

  function loadNextPage(instance, deadline) {
    return new Promise(function(resolve) {
      var pagination = instance.paginationElement || document.querySelector(paginationSelector);
      var link = pagination && pagination.querySelector('a[href]');
      var remaining = deadline - Date.now();
      if (!link || remaining <= 0 || typeof instance.loadMore !== 'function') {
        resolve(false);
        return;
      }

      var finished = false;
      var timeout = window.setTimeout(function() {
        if (instance.request && instance.request.readyState !== 4) {
          try {
            instance.request.abort();
          } catch (error) {
            // The request may already have completed.
          }
        }
        finish(false);
      }, remaining);

      function finish(appended) {
        if (finished) return;
        finished = true;
        window.clearTimeout(timeout);
        document.removeEventListener(appendedEvent, onAppended);
        resolve(Boolean(appended));
      }

      function onAppended() {
        finish(true);
      }

      document.addEventListener(appendedEvent, onAppended);
      try {
        // Drive Ajaxinate's own XHR, append, pagination update, and reinitialization.
        instance.nextPageLinkElement = link;
        instance.nextPageUrl = link.href;
        instance.loadMore();
      } catch (error) {
        finish(false);
      }
    });
  }

  async function loadSavedProducts(grid, targetCount, deadline) {
    while (grid.children.length < targetCount && Date.now() < deadline) {
      var instance = await waitForAjaxinate(deadline);
      if (!instance) return;
      var previousCount = grid.children.length;
      var appended = await loadNextPage(instance, deadline);
      if (!appended || grid.children.length <= previousCount) return;
    }
  }

  function waitForImages(grid, maxWait) {
    var images = Array.prototype.slice.call(grid.querySelectorAll('img')).filter(function(image) {
      return !image.complete;
    });
    if (!images.length || maxWait <= 0) return Promise.resolve();

    return new Promise(function(resolve) {
      var finished = false;
      var pending = 0;
      var listeners = [];
      var timeout = window.setTimeout(finish, maxWait);

      function finish() {
        if (finished) return;
        finished = true;
        window.clearTimeout(timeout);
        listeners.forEach(function(listener) {
          listener.image.removeEventListener('load', listener.handler);
          listener.image.removeEventListener('error', listener.handler);
        });
        resolve();
      }

      images.forEach(function(image) {
        if (image.complete) return;
        pending += 1;
        var handler = function() {
          pending -= 1;
          if (pending <= 0) finish();
        };
        listeners.push({ image: image, handler: handler });
        image.addEventListener('load', handler);
        image.addEventListener('error', handler);
      });

      if (pending === 0) {
        finish();
      }
    });
  }

  function scrollToSavedPosition(targetY) {
    return new Promise(function(resolve) {
      var reduceMotion = false;
      try {
        reduceMotion = window.matchMedia &&
          window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      } catch (error) {
        reduceMotion = false;
      }

      var startY = window.pageYOffset || document.documentElement.scrollTop || 0;
      var distance = targetY - startY;
      if (
        reduceMotion ||
        Math.abs(distance) < 2 ||
        typeof window.requestAnimationFrame !== 'function'
      ) {
        window.scrollTo(0, targetY);
        resolve(true);
        return;
      }

      var finished = false;
      var frameId = null;
      var startTime = null;
      var duration = Math.min(700, Math.max(320, Math.abs(distance) / 14));
      var timeout = window.setTimeout(function() { finish(true, true); }, 850);

      function finish(alignTarget, reachedTarget) {
        if (finished) return;
        finished = true;
        window.clearTimeout(timeout);
        if (frameId !== null && typeof window.cancelAnimationFrame === 'function') {
          window.cancelAnimationFrame(frameId);
        }
        window.removeEventListener('wheel', cancelForUserInput);
        window.removeEventListener('touchstart', cancelForUserInput);
        window.removeEventListener('pointerdown', cancelForUserInput);
        window.removeEventListener('keydown', cancelForUserInput);
        if (alignTarget) window.scrollTo(0, targetY);
        resolve(Boolean(reachedTarget));
      }

      function cancelForUserInput() {
        finish(false, false);
      }

      function animate(timestamp) {
        if (startTime === null) startTime = timestamp;
        var progress = Math.min(1, (timestamp - startTime) / duration);
        var easedProgress = 1 - Math.pow(1 - progress, 3);
        window.scrollTo(0, startY + distance * easedProgress);

        if (progress < 1) {
          frameId = window.requestAnimationFrame(animate);
          return;
        }

        window.scrollTo(0, targetY);
        finish(false, true);
      }

      window.addEventListener('wheel', cancelForUserInput, { passive: true });
      window.addEventListener('touchstart', cancelForUserInput, { passive: true });
      window.addEventListener('pointerdown', cancelForUserInput, { passive: true });
      window.addEventListener('keydown', cancelForUserInput);
      frameId = window.requestAnimationFrame(animate);
    });
  }

  async function restoreState(state) {
    var deadline = Date.now() + 2000;
    isRestoring = true;
    try {
      var grid = await waitForGrid(deadline);
      if (!grid) return;

      var pagination = document.querySelector(paginationSelector);
      var mode = pagination && pagination.getAttribute('data-pagination');
      if ((mode === 'click' || mode === 'scroll') && Number.isFinite(state.loadedProductCount)) {
        await loadSavedProducts(grid, state.loadedProductCount, deadline);
      }

      var targetY = Math.max(0, Number(state.scrollY) || 0);
      var reachedTarget = await scrollToSavedPosition(targetY);
      await waitForImages(grid, Math.min(450, Math.max(0, deadline - Date.now())));
      // Correct any small layout shift caused by images that settled during the scroll.
      if (reachedTarget) window.scrollTo(0, targetY);
    } finally {
      isRestoring = false;
      resetScrollRestoration();
    }
  }

  function restoreCurrentUrl() {
    var state = readState(currentUrlKey());
    if (!state) {
      resetScrollRestoration();
      return false;
    }
    setManualRestoration();
    restoreState(state);
    return true;
  }

  function beginHistoryRestore() {
    var state = readState(currentUrlKey());
    if (!state) {
      facetRestorePending = false;
      return false;
    }
    facetRestorePending = true;
    setManualRestoration();
    window.setTimeout(function() {
      if (facetRestorePending) {
        facetRestorePending = false;
        resetScrollRestoration();
      }
    }, 2500);
    return true;
  }

  function restoreAfterFacets() {
    if (!facetRestorePending) return;
    facetRestorePending = false;
    restoreCurrentUrl();
  }

  function isBackForwardLoad() {
    try {
      var entries = window.performance && window.performance.getEntriesByType('navigation');
      return Boolean(entries && entries[0] && entries[0].type === 'back_forward');
    } catch (error) {
      return false;
    }
  }

  function maybeRestore(event) {
    if (restoreStarted || !(isBackForwardLoad() || (event && event.persisted))) return;
    var state = readState(currentUrlKey());
    if (!state) return;
    restoreStarted = true;
    setManualRestoration();
    restoreState(state);
  }

  window.theme = window.theme || {};
  window.theme.collectionScrollRestore = {
    saveCurrent: saveCurrent,
    beginHistoryRestore: beginHistoryRestore,
    restoreAfterFacets: restoreAfterFacets
  };

  window.addEventListener('pagehide', function() {
    saveCurrent();
  });

  window.addEventListener('scroll', function() {
    if (saveTimer) window.clearTimeout(saveTimer);
    saveTimer = window.setTimeout(function() {
      saveTimer = null;
      saveCurrent();
    }, 150);
  }, { passive: true });

  document.addEventListener('click', function(event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var target = event.target && event.target.nodeType === 1 ? event.target : event.target && event.target.parentElement;
    var link = target && target.closest ? target.closest('a[href]') : null;
    if (!link || (link.target && link.target !== '_self')) return;
    try {
      var destination = new URL(link.href, window.location.href);
      if (destination.origin === window.location.origin && /\/products\//.test(destination.pathname)) {
        saveCurrent();
      }
    } catch (error) {
      // Ignore malformed or nonstandard links.
    }
  }, true);

  document.addEventListener(facetsRenderedEvent, function() {
    if (facetRestorePending) {
      restoreAfterFacets();
    } else {
      saveCurrent();
    }
  });
  document.addEventListener(appendedEvent, function() {
    saveCurrent();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { maybeRestore(null); }, { once: true });
  } else {
    maybeRestore(null);
  }
  window.addEventListener('pageshow', maybeRestore);
})();
